import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';

var _templateObject;
var StyledLoader = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  border-color: ", ";\n  border-width: ", ";\n  border-style: solid;\n  border-top-color: transparent;\n  border-radius: 50%;\n"])), function (_ref) {
  var $size = _ref.$size;
  return $size;
}, function (_ref2) {
  var $size = _ref2.$size;
  return $size;
}, function (_ref3) {
  var theme = _ref3.theme,
    $colour = _ref3.$colour;
  return $colour || theme.colours.ink.primary.main;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.sizing.xtiny;
});

export { StyledLoader, StyledLoader as default };
//# sourceMappingURL=Loader.styles.js.map
